import React, { Component } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faTrash } from '@fortawesome/free-solid-svg-icons';
import { HOTELEMPLOYEE_SEARCHURL, HOTELEMPLOYEE_ADDURL, HOTELEMPLOYEE_DELETEURL } from './../constants/index';

import Header from './Header';
import Benefits from './Benefits.js';
import LoadingScreen from './common/loading-screen';
import HotelEmployeeAddModal from './HotelEmployeeAddModal';

// import membership price function
import { getMembershipPrice } from '../utilities/getMembershipPrice.js';

import { getUrl, isProd, getBenefits, tailorSort } from './helper';
import SelectEmployee, {
  EmployeeDeleteModal,
  EmployeeDeleteToast,
} from "./SelectEmployee/index.js";
    

class EmployeeDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show         : false,
            apiError     : false,
            ErrorMessage : '',
            showError    : false,
            staffName    : '',
            employeeList : {},
            fetchingData : true,
            addingData   : false,
            benefitsProduct    : [],
            employeeId   :  "",
            showDeleteModal: false,
            isDeleted    : false,
            deleteResponse: {}, 
            membershipPrice : [],
            membershipPriceLoading: true,
            hotelSalesBC : "",
        };
        this.getEmployees = this.getEmployees.bind(this);
    }

    componentWillMount = () => {
        if(localStorage.getItem('hotelData') && this.props.history.location.state.language){
            const hotelData = JSON.parse(localStorage.getItem('hotelData'));
            this.setState({
                countryCode        : hotelData.CountryCode
            });
            this.setState({
                benefitsProduct: getBenefits(hotelData.CountryCode),
                
            })
            getMembershipPrice(hotelData.CountryCode)
                .then(membershipPrice => this.setState({membershipPrice: membershipPrice[0], membershipPriceLoading: false, hotelSalesBC: membershipPrice[1].business_category}))
                .catch(error => {
                    console.log('Error getting Membership Price', error)
                    this.setState({membershipPriceLoading: false})
            });
        }else{
            window.location.href = "/";
        }

        if(localStorage.getItem('staffName')){
            const name = localStorage.getItem('staffName');
            this.setState({
                staffName        : name
            });
        }
        let employees = this.getEmployees();
        Promise.all([employees]).then(() =>{
            this.setState({ fetchingData     : false });
        });
    }

    showModal = (e) => {
        e.preventDefault();
        this.setState({ show: true });
      };
    
    hideModal = () => {
        this.setState({ show: false });
    };

    
    deleteModalHandler = () => {
      this.setState({
        showDeleteModal: !this.state.showDeleteModal,
        errorMessage: "",
        apiError: false,
      });
    };
  
    setEmployeeId = (id) => {
      this.setState({ employeeId: id });
    };

    setEmployeeId = (id) => {
      this.setState({ employeeId: id });
    };
    
    staffNameHandler = (name) => {
      this.setState({ staffName: name });
    };

    getEmployees = async () => {
        const { state } = this.props.history.location;
        var env = isProd() ? true : false;
        await axios.get(`${HOTELEMPLOYEE_SEARCHURL}?HotelCode=${state.hotelCode}&env=${env}`)
            .then(response => {
                if (response.status === 200) {
                    if(!response?.data?.length){
                        this.staffNameHandler("");
                        this.setState({
                            employeeList : []
                        });
                        return;
                    };
                    this.setState({
                        employeeList : tailorSort(response.data, "Name")
                    });
                } 
            }).catch(error => {
                console.error("ERROR", error);
                return {};
            });
    }

    handleNext = () => {
        let {staffName, countryCode, hotelSalesBC} =this.state;
        const { state } = this.props.history.location;
        const urlRoot = getUrl().urlRoot;
        const BUSINESS_CATEGORY = hotelSalesBC;
        let priceLevel;
        localStorage.setItem('staffName',staffName);
        if(!staffName){
            this.setState({showError: true});
        }else{
            if( countryCode === "CN" ||countryCode === "MO" ) countryCode = "HK";
       
            priceLevel = "&bc=" + BUSINESS_CATEGORY;

            let url = new URL(urlRoot + countryCode.toLowerCase() + "/registration/?"+priceLevel+"&hotelRIDOnlineKiosk="+state.hotelCode+"&apHotelEmployeeName="+staffName+"&hotelEmployee="+staffName+"&redirect=F");
            // console.log('url countryCode', countryCode)
            // console.log('url', url.href)
            window.location.href = url;
            // const url =  urlRoot + countryCode.toLowerCase() + "/registration/#primary-product-selection?redirect=F&hotelRIDOnlineKiosk="+state.hotelCode+"&apHotelEmployeeName="+staffName+"&hotelEmployee="+staffName + priceLevel;
        }
    };

    leaderBoard = () => {
        const { state } = this.props.history.location;
        if(state.showLeaderBoard){
            this.props.history.push('/leaderboard', { 
                hotelCode      : state.hotelCode, 
                hotelName      : state.hotelName,
                countryName    : this.state.countryName
            });
        }
    }

    addEmployee = async (name) => {
        const { state } = this.props.history.location;
        this.setState({addingData : true});
        if(name){
            await axios.post(`${HOTELEMPLOYEE_ADDURL}`,{
                HotelCode : state.hotelCode,
                Name      : name,
                env       : isProd() ? 'true' : 'false'
            })
            .then(response => {
                this.setState({addingData : false});
                if(response.data.errorMessage){
                    console.error(response.data.errorMessage)
                    this.setState({
                        apiError : true,
                        errorMessage : response.data.errorMessage
                    })
                }else{
                    this.setState({ show: false });
                    this.getEmployees();
                }
            }).catch(error => {
                console.error("ERROR", error);
                return {};
            });
        }else{
            this.setState({
                apiError : true,
                errorMessage : "The above field cannot be blank."
            })
        }
    }

    removeEmployee = async (id) => {
      const { state } = this.props.history.location;
  
      if (!id) {
        this.setState({
          apiError: true,
          errorMessage: "Missing ID or employee does not exist!",
        });
        return;
      }
  
      await axios
        .delete(`${HOTELEMPLOYEE_DELETEURL}`, {
          data: { id, env: isProd() },
        })
        .then((response) => {
          if (response.data.errorMessage) {
            console.error(response.data.errorMessage);
            this.setState({
              apiError: true,
              errorMessage: response.data.errorMessage,
            });
          } else {
            this.setState({
              staffName: state.language.enterStaffName,
              deleteResponse: response.data,
              isDeleted: true,
              showDeleteModal: false,
            });
            this.getEmployees();
          }
        })
        .catch((error) => {
          console.error("ERROR", error);
          return;
        });
    };


    render() {
        const { state } = this.props.history.location;
        const { showError, staffName, employeeList, fetchingData, show, apiError, errorMessage, showDeleteModal, employeeId, isDeleted, deleteResponse } = this.state;
        
        return (
            <div className="hotelSales-wrapper">
                <Header 
                    showLeaderBoard   = {state.showLeaderBoard}
                    handleLeaderBoard = {this.leaderBoard}
                    bannerClass       = "home banner"/>
                <div className="container mt-5">
                    <div>
                        <h4>{state.language.welcome}</h4>
                        <p>{state.language.beforeWeGetStarted}</p>
                        <p>{state.language.toAssist}</p>
                    </div>
                    <div>
                        <h4>{state.language.supplliedDetails}</h4>
                        <p><strong>{state.language.employeeType}: </strong>{state.language.hotelHeartist}</p>
                        <p><strong>{state.language.hotelDetails}:</strong> {state.hotelName} -RID {state.hotelCode}</p>
                    </div>

                    <div>
                        <h4>{state.language.yourDetails} <sup>*</sup></h4>
                        <p>{state.language.pleaseProvide}</p>
                    </div>

                    <div className="hotel-code-container row">
                        <div className="form-group col-12 col-md-6">
                            <label for="staffName">
                                {state.language.heartistName}<sup>*</sup>
                            </label>
                            {fetchingData ? (
                                    <LoadingScreen extraClass="section-loading"/>
                            ) : (
                                <React.Fragment>
                                {employeeList.length > 0 ? ( 
                                  <SelectEmployee
                                   className={`form-control rounded selectpicker ${
                                     showError ? "border border-danger" : ""
                                   }`}
                                   defaultText={state.language.enterStaffName}
                                   setEmployeeId={this.setEmployeeId}
                                   setStaffName={this.staffNameHandler}
                                   employeesValue={employeeList}
                                   staffName={staffName}
                                   isDeleted={isDeleted}
                                 />
                                  ) : (
                                    <div>No Heartist records found for this Hotel.</div>
                                  )}
                                    <div className="d-flex justify-content-between">
                                    <button
                                    className="btn btn-primary mt-2"
                                    onClick={this.showModal}
                                    >
                                    Add Heartist
                                    </button>

                                    {staffName && (
                                    <button
                                    className="btn btn-danger mt-2"
                                    onClick={this.deleteModalHandler}
                                    >
                                    Remove Heartist <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                    )}
                                    </div>
                                </React.Fragment>
                            )}
                            
                            {showError && (
                                <div className="error">{state.language.missingEmployee}</div>
                            )}
                        </div>
                    </div>

                    <div className="mt-2">
                        <p>{state.language.whyWeNeedThis}</p>
                    </div>

                    <div className="d-flex justify-content-between">
                        <p class="disclaimer">*{state.language.mandatoryQuestion}</p>
                    </div>

                    <div className="d-flex justify-content-between">
                        <button className="btn btn-primary" onClick={()=> this.props.history.goBack()}><FontAwesomeIcon icon={faChevronLeft} /> {state.language.back}</button>
                        <button className="btn btn-primary" onClick={this.handleNext}>{state.language.next}<FontAwesomeIcon icon={faChevronRight} /></button>
                    </div>
                </div>
            
                <Benefits 
                    data = {state.benefitResults}
                    benefitsProduct = {this.state.benefitsProduct}
                    membershipPrice = {this.state.membershipPrice}
                    membershipPriceLoading = {this.state.membershipPriceLoading}
                />
                <HotelEmployeeAddModal 
                    show         = {show}  
                    language     = {state.language}
                    apiError     = {apiError}
                    errorMessage = {errorMessage}
                    handleClose  = {this.hideModal} 
                    add          = {this.addEmployee}
                    loading      = {state.addingData} />

                <EmployeeDeleteModal
                          showDeleteModal={showDeleteModal}
                          handleDeleteModal={this.deleteModalHandler}
                          apiError={apiError}
                          errorMessage={errorMessage}
                          employeeId={employeeId}
                          removeEmployee={this.removeEmployee}
                          isDeleted={isDeleted}
                        />

                <EmployeeDeleteToast
                  show={isDeleted}
                  message={deleteResponse?.message}
                  delay={2000}
                  onClose={() => this.setState({ isDeleted: false })}
                  autohide
                />
            </div>
        );
    }

}

export default EmployeeDetail;
